export enum LocalStorageKeys {
  ACCESS_TOKEN = 'accessToken',
}
